import * as insightsAPI from '../api/insights.js';
import { fetchLoadable } from '../fetchLoadable.js';
import { dispatch } from '../internal.js';
import * as actionTypes from './actionTypes.js';
export const getCaseFilterCount = (caseFilter) => fetchLoadable(actionTypes.FETCH_CASE_FILTER_COUNT, insightsAPI.getCaseFilterCount, { caseFilter });
export const setSelectedCreditors = (creditors) => dispatch({ type: actionTypes.SET_SELECTED_CREDITORS, payload: { creditors } });
export const updateFilter = (filter) => dispatch({ type: actionTypes.UPDATE_FILTER, payload: { filter } });
export const clearFilter = (filterName, isDate, dateField) => dispatch({
    type: actionTypes.CLEAR_FILTER,
    payload: { filterName, isDate, dateField },
});
//# sourceMappingURL=actions.js.map